import { supabase } from '@/lib/supabase';
import { ContactMessage, ContactMessageInsert } from '@/types/contact.types';

interface ContactMessageResponse {
  data: ContactMessage | null;
  error: Error | null;
}

export const contactMessageService = {
  async create(message: ContactMessageInsert): Promise<ContactMessageResponse> {
    try {
      // Convert camelCase to snake_case for database
      const { data, error } = await supabase
        .from('contact_messages')
        .insert({
          inquiry_type: message.inquiryType,
          full_name: message.fullName,
          email: message.email,
          phone: message.phone,
          company: message.company || null,
          message: message.message,
        })
        .select()
        .single();

      if (error) throw error;

      // Convert snake_case to camelCase for application
      const contactMessage: ContactMessage = {
        id: data.id,
        inquiryType: data.inquiry_type,
        fullName: data.full_name,
        email: data.email,
        phone: data.phone,
        company: data.company,
        message: data.message,
        status: data.status,
        createdAt: data.created_at,
        updatedAt: data.updated_at,
      };

      return { data: contactMessage, error: null };
    } catch (error) {
      return {
        data: null,
        error: error instanceof Error ? error : new Error('Failed to send message'),
      };
    }
  },
};